import React, {useState, useEffect} from 'react';

import {  useNavigate } from 'react-router-dom';

import UniversalModall, { useModal } from '../../../../components/AlertModal/UniversalModal';
import KindergartensList from '../../../kindergartens/list/components/KindergartensPage/KindergartensPage';

import { authService } from '../../../../services/authService';



const EditModeDouKG = () => {

    
    const {
        modalProps,
        alert,
        confirm,
        prompt,
        success,
        error,
        warning,
        Modal
    } = useModal();


    const handleConfirm = async (kg_id) => {
        const result = await confirm('Перейти в режим редагування садочку?');

        if (result.button === 'Підтвердити') {
            const firstPage = await authService.changeRole({ role: 'kindergartenHead', area: kg_id});
            if(!firstPage) return alert('Виникла помилка, спробуйте пізнійше');
            return navigate(firstPage,  { replace: true });
        } else {
        console.log('Користувач скасував дію');
        }
    };

  const navigate = useNavigate();

  const handleSchoolSelect = (kgId) => {

    handleConfirm(kgId);
    
  };

  return (
    <div className="form-section form-section--wide">
      {false && <h2 className="form-section-title">{'Обрання садочку'}</h2>}
      <KindergartensList isListView={true} isChecked={true} listChecked={[]} onCheck={handleSchoolSelect} isFixed={false} uncheckAll={()=>{}}/>
      <Modal />
    </div>
  );
};

export default EditModeDouKG;